'use client'

import { Separator as SeparatorPrimitive } from '@base-ui/react/separator'
import { cn } from '@/lib/utils'

/*
 * GoodUnited / Separator. Figma: 10 / Components / Separator.
 * A 1px rule in Colors/border/subtle.
 */
function Separator({ className, orientation = 'horizontal', ...props }: Omit<SeparatorPrimitive.Props, 'className'> & { className?: string }) {
    return (
        <SeparatorPrimitive
            data-slot='separator'
            orientation={orientation}
            className={cn('shrink-0 bg-border-subtle data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch', className)}
            {...props}
        />
    )
}

export { Separator }
